import { render, staticRenderFns } from "./shareSdk.vue?vue&type=template&id=07a9ca94"
import script from "./shareSdk.vue?vue&type=script&lang=js"
export * from "./shareSdk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports